import Icon from '../components/Icon.vue'

Icon.register({
  republican: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 192v64h-544v-64c0-88.4 71.6-160 160-160h224c88.4 0 160 71.6 160 160zM176.3 170.4c3.5-3.5 1.6-9.5-3.4-10.2l-27.4-4-12.2-24.8c-2.1-4.4-8.5-4.5-10.7 0l-12.2 24.8-27.4 4c-4.9 0.7-6.9 6.7-3.3 10.2l19.8 19.3-4.7 27.3c-0.8 4.9 4.4 8.6 8.7 6.3l24.5-12.9 24.5 12.9c4.4 2.3 9.5-1.4 8.7-6.3l-4.7-27.3zM320.3 170.4c3.5-3.5 1.6-9.5-3.4-10.2l-27.4-4-12.2-24.8c-2.1-4.4-8.5-4.5-10.7 0l-12.2 24.8-27.4 4c-4.9 0.7-6.9 6.7-3.3 10.2l19.8 19.3-4.7 27.3c-0.8 4.9 4.4 8.6 8.7 6.3l24.5-12.9 24.5 12.9c4.4 2.3 9.5-1.4 8.7-6.3l-4.7-27.3zM464.3 170.4c3.5-3.5 1.6-9.5-3.4-10.2l-27.4-4-12.2-24.8c-2.1-4.4-8.5-4.5-10.7 0l-12.2 24.8-27.4 4c-4.9 0.7-6.9 6.7-3.3 10.2l19.8 19.3-4.7 27.3c-0.8 4.9 4.4 8.6 8.7 6.3l24.5-12.9 24.5 12.9c4.4 2.3 9.5-1.4 8.7-6.3l-4.7-27.3zM624 320c8.8 0 16 7.2 16 16v64c0 46.9-40.6 84.5-88.4 79.6-41.6-4.2-71.6-42.5-71.6-84.3v-43.3h-32v112c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-80h-192v80c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-176h544v112c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8 7.2-16 16-16h32z'
      }
    ]
  }
})
